export default "__VITE_PUBLIC_ASSET__32957328__"